export default "__VITE_ASSET__BNbXc_pB__"